import Vue from 'vue';
import App from './App.vue';
import VueCompositionApi from '@vue/composition-api';
import router from './router';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import { store } from './store/index';
import { axios } from './plugins/axios';
import { endPoints } from './shared/types/api';
import { MASTER_DATA_MUTATION } from './store/mutations/mutationTypes';

Vue.use(VueCompositionApi);
Vue.config.devtools = true;
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  vuetify,
  created() {
    axios.get(endPoints.getParameters.endPoint).then((res) => {
      store.commit(MASTER_DATA_MUTATION.SET_GET_PARAMETERS, res.data);
    });
  },
  render: (h) => h(App),
}).$mount('#app');
